import { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "How long does shipping take?",
    a: "Orders ship within 1–2 business days of payment confirmation. Most U.S. buyers receive their kits in 2–4 business days after ship-out. All kits leave from a temperature-controlled facility.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We accept all major credit cards, Venmo, and Cash App. Manual-payment orders (Venmo / Cash App) show the exact amount, our handle, and a scannable QR code after checkout — send payment with your order number in the note and we ship as soon as we confirm receipt.",
  },
  {
    q: "How do I track my order?",
    a: "Once your order ships you'll receive an email with tracking. Your full order history and status is always visible under Orders while signed in.",
  },
  {
    q: "How should I store the kits when they arrive?",
    a: "Store lyophilized (freeze-dried) vials in a cool, dry, dark place — refrigerated is best for long-term storage. Once reconstituted, follow standard cold-chain research protocols for the compound in question.",
  },
  {
    q: "Is packaging discreet?",
    a: "Yes. All orders ship in plain, unmarked padded mailers or boxes with no product name, no logos, and no reference to the contents on the exterior label.",
  },
  {
    q: "Is any of this for human or animal use?",
    a: "No. Every product sold on BulkBuyKits.com is strictly for laboratory research and in-vitro study. Nothing offered here is for human consumption, veterinary treatment, or any diagnostic, therapeutic, or clinical purpose. FDA has not evaluated any statement on this site.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <div className="max-w-[820px] mx-auto px-6 lg:px-12 py-14 lg:py-20" data-testid="faq-page">
      <p className="overline mb-4">Support</p>
      <h1 className="font-serif text-5xl md:text-6xl tracking-tight mb-10">Frequently asked.</h1>
      <div className="hairline mb-10" />
      <div className="divide-y divide-borderSubtle border-y border-borderSubtle">
        {FAQS.map((item, idx) => {
          const isOpen = open === idx;
          return (
            <div key={item.q} data-testid={`faq-item-${idx}`}>
              <button
                onClick={() => setOpen(isOpen ? -1 : idx)}
                className="w-full flex items-center justify-between text-left py-5 hover:text-oxblood transition-colors"
                data-testid={`faq-toggle-${idx}`}
              >
                <span className="font-serif text-xl md:text-2xl pr-6 leading-snug">{item.q}</span>
                <ChevronDown
                  size={18}
                  strokeWidth={1.5}
                  className={`shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`}
                />
              </button>
              {isOpen && (
                <div className="pb-6 pr-8 text-charcoal leading-relaxed text-sm">
                  {item.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <p className="text-sm text-stone mt-10">
        Still need help? Reach us at{" "}
        <a href="mailto:support@bulkbuykits.com" className="text-oxblood hover:text-charcoal underline">
          support@bulkbuykits.com
        </a>
        .
      </p>
    </div>
  );
}
